import { Box, LinearProgress, Typography } from "@mui/material";
import type { HunterPrerequisiteItem } from "Components/Hunter/Prerequisites/types";
import { PrerequisiteCompletionStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.Dashboard.Prerequisites;

type Props = {
  items: Array<HunterPrerequisiteItem>;
};

export const PrerequisitesProgress = ({ items }: Props) => {
  const { t } = useResource();

  const completedCount = items.filter(
    (item) =>
      item.completionStatus !== PrerequisiteCompletionStatus.NotCompleted,
  ).length;
  const totalCount = items.length;
  const percentage =
    totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

  return (
    <Box>
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          height: 10,
          borderRadius: 4,
          backgroundColor: "grey.200",
          "& .MuiLinearProgress-bar": {
            borderRadius: 4,
          },
        }}
      />
      <Box display="flex" alignItems="center" gap={1} mt={1}>
        <Typography variant="body1" fontWeight={400}>
          {percentage}% {t(RESOURCES.Completed)}
        </Typography>
        {percentage > 0 && (
          <Typography variant="body1" color="primary.main" fontWeight={400}>
            - {t(RESOURCES.GreatWork)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
